export enum ServiceModelsActions {
    FETCH_VIEW = 'FETCH_VIEW',
    DOWNLOAD_SERVICE_MODEL = 'DOWNLOAD_SERVICE_MODEL',
    DELETE_SERVICE_MODEL = 'DELETE_SERVICE_MODEL',
}
